import FlatPickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import ReactFlatPickr from 'react-flatpickr';

import type { CustomLocale } from 'flatpickr/dist/types/locale';

import type { DatePickerBaseProps } from './DatePickerBase.types';
import './Flatpickr.custom.scss';
import usePresenter from './DatePickerBase.presenter';
import { customLocale } from './DatePickerBase.constants';

FlatPickr.localize(customLocale as CustomLocale);

const DatePickerBase = (props: DatePickerBaseProps) => {
  const {
    datePickerRef,
    disabled,
    required,
    onDateChange,
    onCloseDatePicker,
    onOpenDatePicker,
    handleDayCreate,
    handleCalendarReady,
    value,
    flatpickrOptions,
  } = usePresenter(props);

  const { renderInput } = props;

  return (
    <ReactFlatPickr
      ref={datePickerRef}
      disabled={disabled}
      required={required}
      value={value}
      options={flatpickrOptions}
      {...(renderInput ? { render: renderInput } : {})}
      onChange={onDateChange}
      onClose={onCloseDatePicker}
      onOpen={onOpenDatePicker}
      onDayCreate={handleDayCreate}
      onReady={handleCalendarReady}
    />
  );
};

export default DatePickerBase;
